import React from "react";
import { FaCircleXmark } from "react-icons/fa6";
import BeatLoader from "react-spinners/BeatLoader";
import ModalContainer from "../../../Components/ModalContainer";
import { useRunEngagementCampaignsMutation } from "../../../Data/services/engagementApi";
import Toast, { SuccessToast } from "../../../Hooks/useToast";
import styles from "../styles/modal.module.scss";
import { extractData } from "../utils";

export default function RunEngagementModal({ open, onClose }) {
  const [runEngagement, { isLoading }] = useRunEngagementCampaignsMutation();

  if (!open) return null;

  const handleConfirm = async () => {
    try {
      const response = await runEngagement().unwrap();
      const summary = extractData(response) || {};
      SuccessToast(
        response?.message ||
          `Run complete — sent ${summary.sent ?? 0}, skipped ${
            summary.skipped ?? 0
          }, failed ${summary.failed ?? 0}`
      );
      onClose?.();
    } catch (err) {
      Toast(
        err?.data?.message || "Failed to run engagement campaigns",
        "error"
      );
    }
  };

  return (
    <ModalContainer handleClose={onClose}>
      <div className={styles.modalPanel} style={{ width: "min(480px, 92vw)" }}>
        <div className={styles.modalHeader}>
          <div>
            <p className={styles.modalTitle}>Run engagement campaigns</p>
            <p className={styles.modalSubtitle}>
              Sends eligible engagement notifications now
            </p>
          </div>
          <button
            type="button"
            className={styles.closeBtn}
            onClick={onClose}
            aria-label="Close"
          >
            <FaCircleXmark />
          </button>
        </div>

        <div className={styles.modalBody}>
          <p className="m-0" style={{ color: "#1f2937" }}>
            This will evaluate and send eligible engagement notifications now.
            Continue?
          </p>
        </div>

        <div className={styles.modalFooter}>
          <button
            type="button"
            className={styles.secondaryBtn}
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            type="button"
            className={styles.primaryBtn}
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? <BeatLoader size={10} color="#fff" /> : "Run now"}
          </button>
        </div>
      </div>
    </ModalContainer>
  );
}
